// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MLXl","questions":"styles_questions__3qImr","footer":"styles_footer__SOCvz"};